import React from 'react';
import { Avatar, Popover, Flex, Typography, Tooltip } from 'antd';
import UserAvatar from '../UserAvatar';

const UserGroup = ({ users, maxCount = 5, avatarSize = 'medium' }) => {
  if (!users || users.length === 0) return null;

  const visibleUsers = users.slice(0, maxCount);
  const excessUsers = users.slice(maxCount);

  const popoverContent = (
    <div style={{ maxHeight: 250, overflowY: 'auto', paddingRight: 8 }}>
      <Flex vertical gap={6}>
        {excessUsers.map((user) => (
          <Flex key={user.id} align="center" gap={8} style={{ padding: '2px 0' }}>
            <UserAvatar user={user} size='small' />
            <Typography.Text strong style={{ fontSize: 12 }}>
              {`${user.first_name} ${user.last_name ?? ''}`}
            </Typography.Text>
          </Flex>
        ))}
      </Flex>
    </div>
  );

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      style={{ display: 'inline-block', cursor: 'default' }}
    >
      <Avatar.Group>
        {visibleUsers.map((user) => (
          <Tooltip title={`${user.first_name} ${user.last_name ?? ''}`} key={user.id}>
            <span style={{ display: 'inline-block' }}>
              <UserAvatar user={user} size={avatarSize} />
            </span>
          </Tooltip>
        ))}
        {excessUsers.length > 0 && (
          <Popover
            title={<Typography.Text strong>Other Users</Typography.Text>}
            content={popoverContent}
            trigger="hover"
          >
            <Avatar
              size={avatarSize}>
              +{excessUsers.length}
            </Avatar>
          </Popover>
        )}
      </Avatar.Group>
    </div>
  );
};

export default UserGroup;
